var React = require('react');

function Heart60px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M55.461 26.643l-.002.004-22.166 24.278c-.873.977-2.056 1.521-3.322 1.521h-.001c-1.266 0-2.448-.544-3.329-1.53L4.485 26.647l-.002-.004c-6.011-6.101-6.002-15.998.03-22.085 6.026-6.078 15.82-6.091 21.869-.047l.008.004 3.581 3.198 3.585-3.198c.002-.001.004-.001.005-.003 6.046-6.044 15.842-6.032 21.87.046 6.028 6.087 6.037 15.984.03 22.085zM54.017 5.985c-5.266-5.309-13.83-5.308-19.092 0-.007.008-.018.01-.026.017-.008.008-.01.018-.019.026l-4.247 3.788c-.053.047-.116.072-.175.106-.038.022-.071.051-.112.068a.983.983 0 0 1-.375.08.999.999 0 0 1-.378-.081c-.038-.015-.068-.043-.104-.063-.062-.035-.127-.061-.181-.11l-4.244-3.788c-.009-.008-.012-.019-.02-.027-.007-.007-.017-.009-.024-.016-5.263-5.308-13.829-5.308-19.093 0a13.597 13.597 0 0 0-3.954 9.632c0 3.639 1.404 7.059 3.954 9.632.006.006.007.014.013.019.004.005.011.007.016.012l22.163 24.277c.504.565 1.159.87 1.852.87.693 0 1.348-.305 1.845-.861L53.988 25.28c.005-.005.011-.007.016-.012.006-.005.007-.013.013-.019 5.26-5.311 5.26-13.953 0-19.264z","key":1})]);
}

Heart60px.displayName = "Heart60px";

Heart60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.97 52.44"};

module.exports = Heart60px;

Heart60px.default = Heart60px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/heart-60px.svg
// module id = 1196
// module chunks = 0